import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateCertificate,
  Certificate,
  CreateLetsEncryptCertificateDTO,
  CreateSelfSignedCertificateDTO,
  CreateCustomCertificateDTO,
} from '../../shared/models/certificate.models';

@Injectable({
  providedIn: 'root',
})
export class CertificateService {
  private http = inject(HttpClient);

  createCertificate(data: CreateCertificate): Observable<Certificate> {
    return this.http.post<Certificate>('/ssl-controller/certificate', data);
  }

  deleteCertificate(websiteId: number): Observable<void> {
    return this.http.delete<void>(`/ssl-controller/certificate/${websiteId}`);
  }

  getCertificate(domain: string): Observable<Certificate> {
    return this.http.get<Certificate>(`/ssl-controller/certificate/${domain}`);
  }

  getCertificateById(id: string): Observable<Certificate> {
    return this.http.get<Certificate>(`/ssl-controller/certificates/${id}`);
  }

  searchCertificates(page: number, domain: string): Observable<Certificate[]> {
    if (!page || page < 1) page = 1;

    return this.http.get<Certificate[]>(
      `/ssl-controller/certificate?page=${page}&search=${domain}`,
    );
  }

  renewCertificate(id: number): Observable<string> {
    return this.http.patch<string>(`/ssl-controller/certificate/${id}`, {});
  }

  registerCustomCertificate({
    websiteId,
    certificate,
    key,
    ca,
  }: CreateCustomCertificateDTO): Observable<void> {
    return this.http.post<void>('/ssl-controller/certificate/custom', {
      websiteId,
      certificate,
      key,
      ca,
    });
  }

  createSelfSignedCertificate({
    websiteId,
    altNames,
    autoRenew,
    vhostAliases,
    email,
  }: CreateSelfSignedCertificateDTO): Observable<void> {
    return this.http.post<void>('/ssl-controller/certificate/self-signed', {
      websiteId,
      altNames,
      email,
      autoRenew,
      vhostAliases,
    });
  }

  createLetsEncryptCertificate({
    websiteId,
    subDomains,
    autoRenew,
    vhostAliases,
    email,
  }: CreateLetsEncryptCertificateDTO): Observable<void> {
    return this.http.post<void>('/ssl-controller/certificate/lets-encrypt', {
      websiteId,
      subDomains,
      email,
      autoRenew,
      vhostAliases,
    });
  }
}
